module.exports = __webpack_public_path__ + "img/red.39f1b4f0.svg";